module.exports = __webpack_public_path__ + "static/media/icon-number.78d5029f.svg";